import { render, staticRenderFns } from "./LxMessagingSidebar.vue?vue&type=template&id=076f40f9&scoped=true"
import script from "./LxMessagingSidebar.vue?vue&type=script&lang=js"
export * from "./LxMessagingSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076f40f9",
  null
  
)

export default component.exports